import { Navigate, Outlet, ScrollRestoration } from 'react-router';
import { NavMarketingV2 } from '@/components/marketing/v2/NavMarketingV2';
import { FooterMarketingV2 } from '@/components/marketing/v2/FooterMarketingV2';
import { useIsPwa } from '@/hooks/useIsPwa';

export default function MarketingLayoutV2() {
  const isPwa = useIsPwa();

  if (isPwa) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-paper font-marketing-body text-charcoal-800">
      <NavMarketingV2 />
      <main className="flex-1">
        <Outlet />
      </main>
      <FooterMarketingV2 />
      <ScrollRestoration />
    </div>
  );
}
